import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LandingPage from '../pages/Landing';
import LoginPage from '../pages/Login';
import ExtractionPage from '../pages/Extraction';
import LeadsPage from '../pages/Leads';

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/landing" element={<LandingPage />} />
    <Route path="/login" element={<LoginPage />} />
    <Route path="/extraction" element={<ExtractionPage />} />
    <Route path="/leads" element={<LeadsPage />} />
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default AppRoutes;
